fragment SmsEditionEngagementStatsFragment on SmsEngagementStats {
    totalSentCount
    responseCount
    responseRate
    undeliveredCount
    undeliveredRate
    optoutCount
    optoutRate
}
